<template>
  <article class="performer-music-item">
    <iframe :src="'https://open.spotify.com/embed/album/' + albumUrl" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
  </article>
</template>

<script>
export default {
  props: {
    albumUrl: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
  .performer-music-item {

    iframe {
      max-width: 740px;
      width: 100%;
      height: 370px;
    }
  }
</style>
